import baseService from './baseService';

export const addFunds = async (packageType) => {
  try {
    const response = await baseService.post('funds/add-funds', {
      ...packageType,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};